import React, { Component } from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import ReactGA from 'react-ga';
import ChapterWisePractiseSessionSection from '../components/chapterWise_PractiseSessions/ChapterWisePractiseSessions';

const PRACTICE_CHAPTER_NAMES = gql`
  query($mobile:String,$exam_id:Int) {
    getPracticeChapterNames(mobile:$mobile,exam_id:$exam_id){
        id
        subject
        practice_chapters {
            chapter_id
            chapter_name
            class_id
        }
    }
  }
`;

class ChapterWisePractiseSessions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headerBottomImg: {
                type: "eamcet_view",
                title: "CHAPTER WISE PRACTISE SESSIONS"
            },
            toggled: "wrapper sidebar-enable",
            submitError: ""

        }

    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };


    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");


        const practiseChapters = this.props.getPracticeChapterNames || [];
        const loading = practiseChapters.loading;
        const error = practiseChapters.error;
        const subjectNames = practiseChapters?.getPracticeChapterNames?.map((item) => ({ id: item.id, subject: item.subject }));

        if (error !== undefined) {
            alert("Server Error. " + error.message);
            return null;
        }

        let globalsubjects = "";
        if (JSON.parse(localStorage.getItem("globalsubjects")) != "") {
            globalsubjects = JSON.parse(localStorage.getItem("globalsubjects"));
        }
        else {
            this.props.history.push("/student/login");
        }

        let studentGlobals = "";
        if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
            studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
        }
        else {
            this.props.history.push("/student/login");
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars
                        headerBottom={this.state.headerBottomImg}
                        onClick={() => this.menuToggler()}
                    />                 </div>
                <div className="main-wrapper">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper" style={{ paddingTop: 10, minHeight: "80vh", backgroundColor: "#f6f7fb" }}>

                        {
                            loading ?
                                (
                                    <Container>
                                        <Row>
                                            <Col sm={12}>
                                                <Image src={require('../../images/rizee_loading.png')} className="loading_img" alt="Lock" />
                                            </Col>
                                        </Row>
                                    </Container>
                                )
                                :
                                (
                                    <ChapterWisePractiseSessionSection
                                        getSubjectOrder={subjectNames}
                                        getPracticeChapterNames={practiseChapters.getPracticeChapterNames}
                                    />
                                )
                        }
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(compose(
    graphql(PRACTICE_CHAPTER_NAMES, {
        options: (props) => ({
            variables: {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile")
            },
            fetchPolicy: 'network-only'
        }), name: "getPracticeChapterNames"
    }),
)(ChapterWisePractiseSessions));
